export default "__VITE_ASSET__187b8c1c__"